import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export default function CommentDeletedSuccessfully() {
    const modalTitle = <Typography>Beitrag erfolgreich gelöscht!</Typography>;
    const modalContent = (
        <ContentTypography>
            Wir würden uns dennoch freuen, bald wieder etwas von dir zu lesen.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
